export const sectionData = [
    {
        id: 1,
        title: 'Подключим быстро',
        text: 'Подключаем интернет в течение 2 дней с момента заявки. Вы можете выбрать удобное для вас время подключения.',
        src: 'clock.png',
    },
    {
        id: 2,
        title: 'Сохраним ремонт',
        text: 'Техник аккуратно проведет кабель без повреждения интерьера вашей квартиры.',
        src: 'roller.png',
    },
    {
        id: 3,
        title: 'Всё настроим',
        text: 'Правильно установим Wi-Fi-роутер — стабильный интернет будет во всей квартире.',
        src: 'servic.png',
    },
];
